import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ScriptLoader from '@s-ui/react-script-loader'

const getGigya = () => window && window.gigya
const gigyaUrl = 'https://cdns.gigya.com/js/gigya.js?apiKey='

const GigyaLoader = ({render, timeoutRender, onTimeout, detectionDelay = 15000}) => {
  const {domain} = useContext(Context)

  const config = domain.get('config')
  const gigyaApiKey = config.get('GIGYA_API_KEY')

  return (
    <ScriptLoader
      src={`${gigyaUrl}${gigyaApiKey}`}
      isAsync
      verifier={getGigya}
      render={render}
      timeoutRender={timeoutRender}
      onTimeout={onTimeout}
      detectionDelay={detectionDelay}
    />
  )
}

GigyaLoader.displayName = 'GigyaLoader'

GigyaLoader.propTypes = {
  render: PropTypes.func.isRequired,
  timeoutRender: PropTypes.func.isRequired,
  onTimeout: PropTypes.func,
  detectionDelay: PropTypes.number
}

export default GigyaLoader
